import React from 'react';

import { observer } from 'mobx-react';

import withDisplayName from 'bz-utilities/hoc/display-name';
import useComputed from 'bz-utilities/hooks/computed';

import { cache } from 'tm3-core/cache';

const ShellTerms = observer(
  withDisplayName((props) => {
    const url = useComputed(() => {
      if (cache.isEClinic) {
        return '/E-Clinic Terms and Conditions.pdf';
      } else if (cache.isGDS) {
        return '/GDS Terms and Conditions.pdf';
      } else if (cache.isPPM) {
        return '/E-Clinic Terms and Conditions.pdf';
      }

      return 'https://www.tm3app.com/terms';
    }, []);

    return (
      <a style={{ color: '#999' }} href={url} target="_blank">
        Terms and Conditions
      </a>
    );
  }, 'ShellTerms')
);

export default ShellTerms;
